import { render } from "./app-system-table.vue?vue&type=template&id=a485bd18&scoped=true&ts=true"
import script from "./app-system-table.vue?vue&type=script&lang=ts"
export * from "./app-system-table.vue?vue&type=script&lang=ts"

import "./app-system-table.vue?vue&type=style&index=0&id=a485bd18&lang=scss"
import "./app-system-table.vue?vue&type=style&index=1&id=a485bd18&lang=scss"
import "./app-system-table.vue?vue&type=style&index=2&id=a485bd18&lang=scss"
import "./app-system-table.vue?vue&type=style&index=3&id=a485bd18&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a485bd18"]])

export default __exports__